// hooks/usePageTracking.js
// Records a page view for every route change: the route PATTERN from
// Util/routesConfig (first match wins, as in <Switch>), so ids in the URL never
// reach analytics. Mounted once in src/Routes.js. See Util/analytics.js.
import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import finalRoutes from "../Util/routesConfig.js";
import { startAnalytics, startPageView } from "../Util/analytics.js";
import { noteRouteChange } from "../Util/goBack.js";

/** { pattern, component } for a pathname, or the generic "(unmatched)". */
export const resolvePage = (pathname) => {
    for (const r of finalRoutes) {
        const paths = Array.isArray(r.path) ? r.path : [r.path];
        for (const path of paths) {
            if (path && matchPath(pathname, { path, exact: r.exact !== false })) {
                return { pattern: path, component: typeof r.component === "string" ? r.component : r.component?.name || null };
            }
        }
    }
    return { pattern: "(unmatched)", component: null };
};

export default function usePageTracking(enabled) {
    const { pathname } = useLocation();

    useEffect(() => {
        if (enabled) startAnalytics();
    }, [enabled]);

    // goBack() only goes back when the user navigated inside the app.
    useEffect(() => { noteRouteChange(); }, [pathname]);

    useEffect(() => {
        if (!enabled) return;
        const { pattern, component } = resolvePage(pathname);
        startPageView(pattern, component);
    }, [enabled, pathname]);
}
